import { render, staticRenderFns } from "./ImageDetailModal.vue?vue&type=template&id=8c29812a&scoped=true"
import script from "./ImageDetailModal.vue?vue&type=script&lang=js"
export * from "./ImageDetailModal.vue?vue&type=script&lang=js"
import style0 from "./ImageDetailModal.vue?vue&type=style&index=0&id=8c29812a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c29812a",
  null
  
)

export default component.exports